import { Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TourismEventSlots } from '@/bag/bag-transport-term/bag-transport-term.model';

@Component({
	selector: 'app-tourism-event-transport-term-slots',
	template:
		'<span matTooltip="Sezon potwierdzone/opcje"> @if (slots() !== undefined && slots() !== null) { {{slots()?.departureOk}}/{{slots()?.departureOp}} } </span>',
	standalone: true,
	imports: [MatTooltip],
})
export class TourismEventTransportTermSlotsComponent {
	readonly slots = input.required<TourismEventSlots>();
}
